import { CompanySpine } from '@/shared/components/common'
import { TaskCard } from '@/features/tasks/components'
import { useT } from '@/shared/i18n'
import { cn } from '@/shared/lib/cn'
import type { Task } from '@/shared/types/domain'

import type { TaskGroup } from '../buckets'

export interface DueSoonGroupProps {
  group: TaskGroup
  onOpen?: (task: Task) => void
  onToggleDone?: (task: Task, done: boolean) => void
  readOnly?: boolean
  className?: string
}

/** Un grupo (persona o proyecto) dentro de un bucket. */
export function DueSoonGroup({
  group,
  onOpen,
  onToggleDone,
  readOnly,
  className,
}: DueSoonGroupProps) {
  const t = useT()
  // El nombre de una persona o de un proyecto lo escribió alguien y viaja tal
  // cual; "Sin responsable" no es de nadie y sale del catálogo.
  const label = group.labelKey ? t(group.labelKey) : group.label

  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <div className="flex items-center gap-2">
        {group.hue !== null ? (
          <CompanySpine hue={group.hue} label={label} className="h-3.5" />
        ) : null}
        <h3 className="text-xs text-text-2">{label}</h3>
        <span className="num text-2xs text-text-3">
          {t('dueSoon.taskCount', { count: group.tasks.length })}
        </span>
      </div>

      <div className="grid gap-1.5 lg:grid-cols-2 xl:grid-cols-3">
        {group.tasks.map((task) => (
          <TaskCard
            key={task.id}
            task={task}
            readOnly={readOnly}
            onOpen={onOpen}
            onToggleDone={onToggleDone}
          />
        ))}
      </div>
    </div>
  )
}
